import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { User } from '@app/store/users/models';
import { UserValue } from '../models';

export const userActions = createActionGroup({
    source: 'User',
    events: {
        'Get User': props<{ id: string }>(),
        'Get User Success': props<{ payload: User }>(),
        'Get User Error': props<{ code: number }>(),

        'Create User': props<{ value: UserValue }>(),
        'Create User Success': emptyProps(),
        'Create User Error': props<{ code: number }>(),

        'Update User': props<{ id: string; value: UserValue }>(),
        'Update User Success': emptyProps(),
        'Update User Error': props<{ code: number }>(),

        'Delete User': props<{ id: string }>(),
        'Delete User Success': emptyProps(),
        'Delete User Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
